import React from 'react';
import VideoPlaylistLabels from './properties/videoPlaylistLabels';

interface VideoScrollbarParams {
  labels: VideoPlaylistLabels;
  onUp: () => void;
  onDown: () => void;
  scrollIndex: number;
  maxScrollIndex: number;
}

const VideoScrollbar: React.FC<VideoScrollbarParams> = (props: VideoScrollbarParams) => {
  const { labels, scrollIndex, maxScrollIndex } = props;

  const disabledUp = () => {
    return scrollIndex <= 0;
  };
  const disabledDown = () => {
    return scrollIndex >= maxScrollIndex;
  };

  const onUp = () => {
    if (disabledUp()) return;
    props.onUp();
  };
  const onDown = () => {
    if (disabledDown()) return;
    props.onDown();
  };

  return (
    <div className="scrollbar">
      <button
        className={`scrollUp ic-arrowUp ${disabledUp() ? 'disabled' : ''}`}
        onClick={onUp}
        role="button"
        aria-hidden="true"
        tabIndex={disabledUp()?-1:0}
        aria-label={labels.previousVideos}
      >
      </button>
      <button
        className={`scrollDown ic-arrowDown ${disabledDown() ? 'disabled' : ''}`}
        onClick={onDown}
        role="button"
        aria-hidden="true"
        tabIndex={disabledDown()?-1:0}
        aria-label={labels.nextVideos}
      >
      </button>
    </div>
  );
};

export default VideoScrollbar;
